interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

const DocumentLinesIcon = ({ width = '20', height = '20', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.334 4.99996V7.01662C18.334 8.33329 17.5007 9.16663 16.184 9.16663H13.334V3.34162C13.334 2.41662 14.0923 1.66663 15.0173 1.66663C15.9257 1.67496 16.759 2.04162 17.359 2.64162C17.959 3.24996 18.334 4.08329 18.334 4.99996Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.66602 5.83329V17.5C1.66602 18.1916 2.44935 18.5833 2.99935 18.1666L4.42435 17.1C4.75768 16.85 5.22435 16.8833 5.52435 17.1833L6.90768 18.575C7.23268 18.9 7.76602 18.9 8.09102 18.575L9.49102 17.175C9.78268 16.8833 10.2493 16.85 10.5743 17.1L11.9993 18.1666C12.5493 18.575 13.3327 18.1833 13.3327 17.5V3.33329C13.3327 2.41663 14.0827 1.66663 14.9993 1.66663H5.83268H4.99935C2.49935 1.66663 1.66602 3.15829 1.66602 4.99996V5.83329Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 10.8417H10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 7.5083H10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.99609 10.8334H5.00358"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.99609 7.5H5.00358"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default DocumentLinesIcon;
